// extracted by mini-css-extract-plugin
module.exports = {"left":"style_left__1EhjS","right":"style_right__2gMQ3","leaderboardItem":"style_leaderboardItem__krmBZ","usersScore":"style_usersScore__29yKY"};